import { render, staticRenderFns } from "./SubpageOverview.vue?vue&type=template&id=4d662054&scoped=true&"
import script from "./SubpageOverview.vue?vue&type=script&lang=js&"
export * from "./SubpageOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d662054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d662054')) {
      api.createRecord('4d662054', component.options)
    } else {
      api.reload('4d662054', component.options)
    }
    module.hot.accept("./SubpageOverview.vue?vue&type=template&id=4d662054&scoped=true&", function () {
      api.rerender('4d662054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/billingpayment/SubpageOverview.vue"
export default component.exports